<template>
  <div class="interface">
    <!-- 导航栏 -->
    <div class="navigation" v-if="navigation">
      <div class="back" @click="Previouspage()"><<<</div>
      <img :src="logUrlList.home" class="home_img" @click="Maininterface()" />
    </div>
    <div class="subject" v-if="threeD_display">
      <div class="header">
      </div>
      <div class="main">
            <div class="cardFaceGroup">
      <div>
        <input id="cardFront" type="radio" v-model="showCardFront" name="cardFaceRd" value="0"></input>
        <label for="cardFront">正面</label>
        /
        <input id="cardBack" type="radio" v-model="showCardFront" name="cardFaceRd" value="1"></input>
        <label for="cardBack">背面</label>
      </div>
    </div>

    <div class="rootDiv" align="center">
      <div id="absoluteDiv" v-bind:class="isHorizontal ? 'absoluteDiv' : 'absoluteDiv vertical'">
        <img ref="frontCover" id="cardFrontCover" v-bind:class="isHorizontal ? 'cardFrontCover' : 'cardFrontCover frontCoverV'"
          v-bind:src="isHorizontal? frontCoverH:frontCoverV"></img>
        <img ref="frontImg" id="cardFrontImg" v-bind:class="isHorizontal ? 'cardFront' : 'cardFront frontV'" v-bind:src="cardFace" />
        <img ref="backCover" id="cardBackCover" v-bind:class="isHorizontal ? 'cardBackCover1' : 'cardBackCover1 backCoverV1'"
          v-bind:src="isHorizontal? backCoverH:backCoverV"></img>
        <img ref="backImg" id="cardBackImg" v-bind:class="isHorizontal ? 'cardBack' : 'cardBack backV'"></img>
      </div>
      <div class="threeD">
        <div class="three_arr" @click="threeD_interface01()" v-if="threeD_01">3D展示01</div>
        <div class="three_arr" @click="threeD_interface02()" v-if="threeD_02">3D展示02</div>
      </div>
    </div>

    <div>
      <b-container>
        <b-row class="rowItem">
          <b-col cols="12">
            <h6>请挑选您的专属卡底</h6>
          </b-col>
          <b-col>
            <div class="parent">
              <div class="RadioStyle item" v-for="(item, index) in kadis" :key="index">
                <!-- <input v-model="kadiColor" type="radio" :id="item.nameCN" name="kadiColorRd" :value="item.id"> -->
                <input v-model="kadiColor" type="radio" :id="item.nameCN" name="kadiColorRd" :value="item.pantoneCode">
                <label :for="item.nameCN" :style="{'background-color':item.hexCode}"></label>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="rowItem" v-show="false">
          <b-col cols="12">
            <h6>请挑选您的专属工艺</h6>
          </b-col>
          <b-col>
            <div class="chk_div imgDiv">
              <div v-for="(item, index) in kgys" :key="index">
                <input v-model="kagongyi" type="radio" :value="item.id" :id="item.technologyName" name="kgyRd">
                <label :for="item.technologyName" :style="{'background-image': 'url(' + item.technologyUrl + ')'}"></label>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="rowItemNotice">
          <b-col>
            <!-- <div style="font-size: 0.8rem;">您须同意《卡面上传图片须知》、《卡面定制服务确认书》</div> -->
          </b-col>
        </b-row>
      <hr/>
        <b-row class="rowItem">
          <b-col cols="1">
            <b-form-checkbox id="checkbox-1" v-model="status" name="checkbox-1" value="accepted" unchecked-value="not_accepted" />
          </b-col>
          <b-col>
            我已阅读并同意遵守<font color="red" @click="showUploadNotice()">《卡面上传图片须知》</font>、<font color="red" @click="showConfirmNotice()">《卡面定制服务确认书》</font>
          </b-col>
        </b-row>
<hr/>
        <b-row class="rowItem">
          <b-col cols="10" class="mx-auto">
            <!-- <b-button block :disabled="disabled" variant="danger" @click="submitAction()">确认支付</b-button> -->
            
          </b-col>
        </b-row>
      </b-container>
    </div>
      </div>
      <div class="footer"><b-button :disabled="disabled" class="toPayButton" @click="submitAction()">确认支付</b-button></div>
    </div>
        <b-modal ok-only ref="model_error" title="提示" @ok="handleOk" ok-title="确定" centered>
      <p class="my-4">{{errorMsg}}</p>
    </b-modal>

     <b-modal ok-only ref="model_modify" title="提示" @ok="handleModifySuccess()" ok-title="确定" centered>
      <p class="my-4">{{modifyMsg}}</p>
    </b-modal>

    <b-modal ref="model_confirm_notice" ok-only scrollable title="卡面定制服务确认书" ok-title="确定" centered>
      <div>
        <p>1. 本人同意接受徽商银行合作伙伴恒宝股份有限公司提供的卡面定制服务并支付相关服务费用。</p>
        <p>2. 本人保证对本人上传的图片拥有知识产权，图片上的人物肖像（如有）为他人肖像的，本人承诺已取得其书面合法授权，
          授权本人和贵行在定制卡面业务中使用其肖像。 如图片上的人物肖像为未成年人，本人承诺为该未成年人的监护人，授权贵行在定制卡面业务中使用其肖像。</p>
        <p>3. 本人知晓并同意定制卡面上传的图片需经过审核通过方可作为卡面使用，本服务提供方有权自主决定审核结果。但审核并不代表对图片肖像权或著作权的认可或承诺。本人知晓并同意，若上传的图片未通过审核，徽商银行有权不予核发。</p>
        <p>4. 本人知晓，如因电脑显示、上传等原因产生色差导致卡面效果产生偏差的，以收到卡片实物效果为准。</p>
        <p>5. 本人承诺因本人提供的图片侵犯违法违规、第三人合法权利、违反《卡面上传图片须知》中的规则或本承诺等情形而发生的争议，本人自行解决，因此给贵行造成的损失，本人承担损失赔偿责任。</p>
        <p>6. 本人知悉并完全理解上述内容，愿意遵守上述约定。如违反上述约定的，本人自愿接受对本人采取的包括但不限于：删除，屏蔽网路信息等必要措施。</p>
      </div>
    </b-modal>


    <b-modal ref="model_upload_notice" ok-only scrollable title="卡面上传图片须知" ok-title="确定" centered>
      <div>
        <p>
          上传图片的专利权、版权、人物肖像权（如有，且用户仅能上传本人或未成年子女照片）、
          商标权、著作权等知识产权均由素材提供方负责，并确保该素材不存在任何侵犯第三人合法权利的因素及遵守以下规则：
        </p>
        <p>1. 不与国家法律法规相违背。</p>
        <p>2. 不含煽动或鼓吹反政府,推翻政府的文字或图像。</p>
        <p>3. 不含有与政治主题相关的文字和图像。</p>
        <p>4. 不含有涉及性、血腥、暴力、裸露、不雅主题及其他可被认定为“社会不能接受”相关主题的文字或图像。</p>
        <p>5. 不含有涉及种族、宗教、民族、性别歧视主题的文字或图像。</p>
        <p>6. 不含有可能引起银行卡诈骗的文字和图像。</p>
        <p>7. 不含有违反社会主义道德和公序良俗的文字和图像。</p>
        <p>8. 不侵害他人肖像权、姓名权、名誉权、隐私权等权利以及他人的知识产权。</p>
        <p>9. 不含有侮辱、诽谤或带有歧视性的文字或图像。</p>
        <p>10. 不含有会引起任何人不适的内容。</p>
        <p>11. 不含有任何名牌产品或服务的图片，以及包括这些品牌的缩写、简写或近似的文字或图像。</p>
        <p>12. 不含有广告促销及招揽性质的文字或图像。</p>
        <p>13. 不含有容易引发误解的语言或数字，包括电话号码或与服务相关的任何文字或图像。</p>
        <p>14. 不含有可能在商户受理卡片过程中产生任何误解和混乱的文字或图像。</p>
        <p>15.其他不适合作为卡面的文字或图像。</p>
      </div>
    </b-modal>

    <div v-show="loading">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">上传中</p>
      </div>
    </div>

    <div v-show="showToast">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <p class="weui-toast__content">{{toastMsg}}</p>
      </div>
    </div>
    <!-- 卡片3d展示01 -->
    <div  class="threeDisplay01" v-if="threeD_display01">
      <div class="card_arr_heng" v-if="cardOri == 0">
        <img class="card_front01" :src="cardFace" />
        <img class="card_back01" :src="logUrlList.threeD_heng" />
      </div>
       <div class="card_arr_shu" v-if="cardOri == 1">
        <img class="card_front02" :src="cardFace" />
        <img class="card_back02" :src="logUrlList.threeD_shu" />
      </div>
    <div class="three_footer"><div class="toPayButton" @click="threeD_OK01()">确认</div></div>
    </div>
    <!-- 卡片3d展示02 -->
     <div  class="threeDisplay02" v-if="threeD_display02"> 
      <div ref="imageContainer" class="card_container"></div>
      <div class="three_footer"><div class="toPayButton" @click="threeD_OK02()">确认</div></div>
    </div>

  </div>
</template>
<script>
const logUrl = require("@/common/logUrl");
import axios from 'axios'
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
const config = require('@/common/config')
 
export default {
  name: "UploadCardface_demo",
  data() {
    return {
      threeD_01:true,
      threeD_02:true,
      logUrlList: logUrl.logUrl,
      threeD_display:true,
      threeD_display01: false,
      threeD_display02: false,
      navigation:true,
       process:"",
        taskId: "",
        phone: "",
        prompt:"",
        delImageUrl:"",
        cardFace: '',
        selectParam: null,
        cardOri: '',
        bankSerialNumber: '',
        kadiColor: '',
        kagongyi: 2, //卡工艺
        showCardFront: 0,
        isHorizontal: true,
        orderNo: '',
        bankCode: '',
        errorMsg: '',
        modifyMsg: "", //修改图片结果
        coverImages: [],
        frontCoverH: config.config_hs.frontCoverH,
        frontCoverV: config.config_hs.frontCoverV,
        backCoverH: config.config_hs.backCoverH,
        backCoverV: config.config_hs.backCoverV,
        kadis: [{
            id: 4,
            hexCode: '#FFFFFF',
            rgbCode: '',
            nameCN: 'AF002C',
            nameEN: '',
            isUsed: ''
          },
          {
            id: 3,
            hexCode: '#FFD900',
            rgbCode: '',
            nameCN: 'FFD900',
            nameEN: '',
            isUsed: ''
          }
        ],
        kgys: [{
          id: 2,
          technologyName: '立金',
          technologyUrl: ''
        }],
        cardTheme: 2,
        status: 'not_accepted',
        disabled: true,
        loading: false,
        showToast: false,
        toastMsg: '',
        audit: false, //下单时，是否进行AI审核, true 审核, false 不审核

      // 3D部分参数
      threeD_width: null,//长
      threeD_height: null, //宽
      backgroundImage: null, //3D背景
      scene: null,
      camera: null,
      renderer: null,
      card: null,
      controls: null,
      isDragging: false,
      previousMousePosition: {
        x: 0,
        y: 0,
      },
      rotationSpeed: 8 / 1000,
      cardThickness: 50 / 1000, // 卡片厚度
      frontTexture: null, // 正面纹理
      backTexture: null, // 背面纹理
   
    }
  },
 watch: {
      kadiColor: function(newval, oldval) {
        console.log("当前卡底色：" + newval, "之前的卡底色：" + oldval);
        if (newval == 4) {
          //白色
          var wrapper = this.coverImagesWrapper
          for (var i = 0; i < wrapper.length; i++) {
            var item = wrapper[i];
            //默认卡面
            if (item.model == 2) {
      
              this.frontCoverH = item.h_front;
              this.backCoverH = item.h_back;
              this.frontCoverV = item.v_front;
              this.backCoverV = item.v_back;
            }
          }
        } else if (newval == 3) {
          //黄色
          var wrapper = this.coverImagesWrapper
          for (var i = 0; i < wrapper.length; i++) {
            var item = wrapper[i];
            if (item.model == 1) {
         
              this.frontCoverH = item.h_front;
              this.backCoverH = item.h_back;
              this.frontCoverV = item.v_front;
              this.backCoverV = item.v_back;
            }
          }
        }

        var img = this.$refs.backImg;
        for (let i = 0; i < this.kadis.length; i++) {
          let item = this.kadis[i];
          if (item.id == newval) {
            img.style.backgroundColor = item.hexCode;
            break;
          }
        }
      },
      showCardFront: function(newval, oldval) {
        console.log("当前显示卡面的值：" + newval, "之前显示卡面的值：" + oldval);
        var frontCover = this.$refs.frontCover;
        var frontImg = this.$refs.frontImg;
        var backCover = this.$refs.backCover;
        var backImg = this.$refs.backImg;
        if (newval == 0) {
          console.log("显示")
          frontCover.style.display = "";
          frontImg.style.display = "";
          backCover.style.display = "";
          backImg.style.display = "";
        } else {
          console.log("隐藏")
          frontCover.style.display = "none";
          frontImg.style.display = "none";
          backCover.style.display = "";
          backImg.style.display = "";
        }
      },
      kagongyi: function(newval, oldval) {
        console.log("卡工艺：" + newval, "之前显示卡工艺的值：" + oldval);
      },
      status: function(newval, oldval) {
        console.log("newval：" + newval, "oldval：" + oldval);
        if (newval == 'accepted') {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      }
    },
    computed: {
      coverImagesWrapper: function() {
        var temp = this.coverImages;
        var array = [];
        if (temp.length > 0) {
          array = new Array(temp.length);
          for (var i = 0; i < temp.length; i++) {
            var obj = temp[i];
          
            obj.h_front =  obj.h_front;
            obj.h_back = obj.h_back;
            obj.v_front =  obj.v_front;
            obj.v_back =  obj.v_back;

            array[i] = obj;
          }
        }
        return array;
      }
    },
  methods: {
    threeD_interface01() {
      this.threeD_display=false
      this.threeD_display01 = true
      this.navigation=false
    },
    // three  DOM组件消除未解决？  添加新的界面
    // threeD_interface02() {
    //   this.threeD_display=false
    //   this.threeD_display02 = true
    //   if (this.threeD_display02) {
    //   this.initThree();
    //   this.animate();
    //   this.setupEventListeners();}
    // },
    threeD_interface02() {
      var selectParam = JSON.stringify(this.selectParam);
      let cardThemeParam = JSON.stringify(this.cardTheme);
      this.$router.replace({
        name: "ThreeD",
        params: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          selectParam: selectParam,
          cardOri: this.cardOri,
          cardTheme: cardThemeParam,
          targetImg: this.cardFace,
          delImageUrl: this.delImageUrl,
          taskId: this.taskId,
          process: this.process,
          phone: this.phone,
          prompt: this.prompt,
        },
      });
    },
    threeD_OK01() {
      this.threeD_display01=false
      this.threeD_display = true
      this.navigation = true
     
    },
    threeD_OK02() {
      this.cleanUp()
    },
    Previouspage() {
      this.$router.replace({
          name: "SelectCardface_demo",
        });
      // if (this.process == 0) {
      //   // 文生图
      //   this.$router.replace({
      //     name: "AItext_to_image",
      //     params: {
      //       taskId: this.taskId,
      //       phone: this.phone,
      //       backoff: 1,
      //     },
      //   });
      // } else if (this.process == 1) {
      //   // 图文生图
      //   this.$router.replace({
      //     name: "AIimage_text_to_image",
      //     params: {
      //       taskId: this.taskId,
      //       phone: this.phone,
      //       backoff: 1,
      //        style: this.style,
      //       prompt: this.prompt,
      //     },
      //   });
      // } else if (this.process == 2) {
      //   // 图生图
      //   this.$router.replace({
      //     name: "AIimage_to_image",
      //     params: {
      //       taskId: this.taskId,
      //       phone: this.phone,
      //       backoff: 1,
      //         style: this.style,
      //     },
      //   });
      // }  else {
      //    // 收藏夹
      //   this.$router.replace({
      //     name: "AISelectCardface",
      //     params: {
      //       taskId: this.taskId,
      //       phone: this.phone,
      //       backoff: 1,
      //     },
      //   });
      // }
    },
    Maininterface() {
       this.$router.replace({
          name: "HomePage",
        });
    },
      showToastMsg: function(msg) {
        this.toastMsg = msg;
        let that = this;
        that.showToast = true;
        setTimeout(function() {
          that.showToast = false;
        }, 2000);
      },
      showLoading: function() {
        this.loading = true;
      },
      hideLoading: function() {
        this.loading = false;
      },
      showUploadNotice: function() {
        this.$refs['model_upload_notice'].show();
      },
      showConfirmNotice: function() {
        this.$refs['model_confirm_notice'].show();
      },
      handleOk: function(bvModalEvt) {

      },
      showModifySuccess() {
        this.$refs['model_modify'].show();
      },
      handleModifySuccess() {
        this.toHomeHs();
      },
      toHomeHs: function() {
        this.$router.go(-3)
      },
      showErrorMsg: function() {
        this.$refs['model_error'].show();
      },
      hideErrorMsg: function() {
        this.$refs['model_error'].hide();
      },
    submitAction: function () {
      this.delRecords()
        // this.toOrderPay()
        },
      delRecords() {
      let params = {
         phone:this.phone,
         taskId:this.taskId,
      }
      console.log("delRecordsparams--->",params)
      axios.post(config.config_demo.delRecords, params).then(res => {
        console.log("delRecords--->", res)
        if (res.data.code == 200) {
          // 清空储存的手机号码
            // localStorage.removeItem('phone')
          this.toOrderPayres()
            
        } else {
            console.log("delRecords失败")
          }
        })
    },
    toOrderPayres() {
      if (this.selectParam != null && this.selectParam.isModify == 1) {
          this.modifyOrder()
        } else {
          this.submitOrder();
        }
      },
      submitOrder: function() {
        if (this.kadiColor.length == 0) {
          this.showToastMsg('请选择您的卡底色')
          return;
        }

        if (this.kagongyi.length == 0) {
          this.showToastMsg('请选择您的卡工艺')
          return;
        }

        var that = this;
        that.showLoading();


        var myObj = {
          bankSerialNumber: this.bankSerialNumber,
          cardType: 1,
          cardTechnology: this.kagongyi,
          cardTypography: this.cardOri,
          backgroupColor: this.kadiColor,
          cardSubject: this.cardTheme,
          bankCode: this.bankCode,
          facadeImage: "",
          facademd5: "",
          audit: this.audit
        };

        console.log("myObj",myObj);

        this.imgToDataUrl(this.cardFace, (dataUrl) => {
          console.log(dataUrl)
          myObj.facadeImage = dataUrl;
          var facademd5 = this.$md5(dataUrl);
          myObj.facademd5 = facademd5;
          axios({
            method: 'post',
            url: config.config_hs.submitOrder,
            data: myObj,
            onUploadProgress: function(progressEvent) {
              var percent = '0';
              var percentage = '0%';

              if (progressEvent.lengthComputable) {
                percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                percentage = percent + '%';
                console.log(percentage);
              }
            }
          }).then(function(response) {
            that.hideLoading();
            console.log(response);
            var result = response.data;
           
            if (result.code == 0) {
              that.toOrderPay(result);
            } else {
             
              that.errorMsg = result.message;
              that.showErrorMsg();
            }

          }).catch(function(error) {
            that.hideLoading();
            console.log(error);
          })
        })

      },
      modifyOrder: function() {

        if (this.kadiColor.length == 0) {
          this.showToastMsg('请选择您的卡底色')
          return;
        }

        var that = this;
        that.showLoading();
        var myObj = {
          orderNo: this.selectParam.orderNo,
          backgroupColor: this.kadiColor,
          cardTypography: this.cardOri,
          cardTechnology: this.kagongyi,
          facadeImage: "",
          facademd5: "",
          audit: this.audit
        }

        this.imgToDataUrl(this.cardFace, (dataUrl) => {
          console.log(dataUrl)
          myObj.facadeImage = dataUrl;
          var facademd5 = this.$md5(dataUrl);
          myObj.facademd5 = facademd5;

          axios({
            method: 'post',
            url: config.config_hs.modify,
            data: myObj,
            onUploadProgress: function(progressEvent) {
              var percent = '0';
              var percentage = '0%';

              if (progressEvent.lengthComputable) {
                percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                percentage = percent + '%';
                console.log(percentage);
              }
            }
          }).then(function(response) {
            console.log(response);
            that.hideLoading();
            var result = response.data;
            if (result.code == 0) {
              if (that.selectParam.isPayed != true) {
                //支付
                that.toOrderPay(result);
              } else {
                that.modifyMsg = result.message
                that.showModifySuccess()
              }

            } else {
              that.errorMsg = result.message;
              that.showErrorMsg();
            }

          }).catch(function(error) {
            console.log(error);
            that.hideLoading()
          })
        })
      },
      imgToDataUrl: function(url, callback) {
        var Img = new Image(),
        dataURL = '';
        Img.src = url;
        Img.onload = function() { //要先确保图片完整获取到，这是个异步事件
          var canvas = document.createElement("canvas"), //创建canvas元素
          width = Img.width, //确保canvas的尺寸和图片一样
          height = Img.height;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(Img, 0, 0, width, height); //将图片绘制到canvas中
          dataURL = canvas.toDataURL('image/png'); //转换图片为dataURL
          callback(dataURL);
        };
      },
      dataURLtoBlob: function(dataurl) {
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {
          type: mime
        });
      },
      toOrderPay: function(orderObj) {
        console.log("orderObj->" + orderObj)
        var tempObj = {
          orderNo: orderObj.orderNo,
          orderDateTime: orderObj.orderDateTime,
          price: orderObj.price,
          projectName: orderObj.projectName,
          thumbnailFileUrl: orderObj.thumbnailFileUrl,
          bankCode: orderObj.bankCode,
	        deadline: orderObj.deadline,//支付截至日期
          cardTypeId: orderObj.cardTypeId,//1-借记卡 / 2-信用卡
          
        }

        var orderInfo = JSON.stringify(tempObj);
        this.$router.replace({
          name: 'OrderPay_demo',
          params: {
            orderInfo: orderInfo,
            cardFace: this.cardFace
          }
        })
      },
      queryCardTheme: function() {
        let that = this;
        axios.get(config.config_hs.queryBankDict, {
          params: {
            bankCode: config.config_hs.bankCode
          }
        }).then(function(response) {
          console.log("queryCardTheme--->",response)
          let data = response.data;
          that.kadis = data.backgroudColorList;
          that.kgys = data.cardTechnologyList;
        }).catch(function(error) {
          console.log(error)
        });
      },
      getLayoutImageByBankCode: function() {
        let that = this;
        axios.get(config.config_hs.getLayoutImageByBankCode, {
            params: {
              bankCode: config.config_hs.bankCode
            }
          }).then(function(response) {
            console.log("getLayoutImageByBankCode--->", response);
            let data = response.data; 
            that.coverImages = data;
            console.log(that.coverImagesWrapper);
            var wrapper = that.coverImagesWrapper
            for (var i = 0; i < wrapper.length; i++) {
              var item = wrapper[i];
              //默认卡面
              if (item.model == 2) {
                 that.frontCoverH =item.h_front;
                 that.backCoverH =item.h_back;
                 that.frontCoverV =item.v_front;
                 that.backCoverV =item.v_back;
              }
              console.log("frontCoverH:" + that.frontCoverH);
              console.log("backCoverH:" + that.backCoverH);
              console.log("frontCoverV:" + that.frontCoverV);
              console.log("backCoverV:" + that.backCoverV);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
    },
    initThree() {
      // 1. 创建场景
      this.scene = new THREE.Scene();

      // 2. 创建相机
      this.camera = new THREE.PerspectiveCamera(
        75,
        this.$refs.imageContainer.clientWidth / this.$refs.imageContainer.clientHeight,
        0.1,
        1000
      );
      this.camera.position.z = 5;

      // 3. 创建渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setSize(
        this.$refs.imageContainer.clientWidth,
        this.$refs.imageContainer.clientHeight
      );
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.$refs.imageContainer.appendChild(this.renderer.domElement);
      this.renderer.setClearColor(0xffffff); // 设置背景为白色

      // 4. 创建卡片（有厚度的矩形）
      const width = this.threeD_width;
      const height = this.threeD_height;

      // 加载纹理
      const textureLoader = new THREE.TextureLoader();

      // 加载正面和背面图片
      this.frontTexture = textureLoader.load(this.cardFace); // 替换为你的图片路径
      this.backTexture = textureLoader.load(this.backgroundImage); // 替换为你的图片路径

      // 正面和背面
      const frontGeometry = new THREE.PlaneGeometry(width, height);
      const backGeometry = new THREE.PlaneGeometry(width, height);

      // 侧面几何体（用于创建厚度）
      const sideGeometry = new THREE.BoxGeometry(
        width,
        this.cardThickness,
        height
      );

      // 材质
      const frontMaterial = new THREE.MeshBasicMaterial({
        map: this.frontTexture,
        side: THREE.DoubleSide,
      });
      const backMaterial = new THREE.MeshBasicMaterial({
        map: this.backTexture,
        side: THREE.DoubleSide,
      });
      const sideMaterial = new THREE.MeshBasicMaterial({
        color: 0x3861d5,
        side: THREE.DoubleSide,
      });

      // 创建卡片网格
      this.card = new THREE.Group();

      // 正面
      const frontFace = new THREE.Mesh(frontGeometry, frontMaterial);
      frontFace.position.z = this.cardThickness / 2;
      this.card.add(frontFace);

      // 背面
      const backFace = new THREE.Mesh(backGeometry, backMaterial);
      backFace.position.z = -this.cardThickness / 2;
      this.card.add(backFace);

      // 侧面（上）
      const topSide = new THREE.Mesh(
        new THREE.PlaneGeometry(width, this.cardThickness),
        sideMaterial
      );
      topSide.rotation.x = Math.PI / 2;
      topSide.position.y = height / 2;
      this.card.add(topSide);
      // 侧面（下）
      const bottomSide = new THREE.Mesh(
        new THREE.PlaneGeometry(width, this.cardThickness),
        sideMaterial
      );
      bottomSide.rotation.x = Math.PI / 2;
      bottomSide.position.y = -height / 2;
      this.card.add(bottomSide);
      // 侧面（左）
      const leftSide = new THREE.Mesh(
        new THREE.PlaneGeometry(this.cardThickness, height),
        sideMaterial
      );
      leftSide.rotation.y = Math.PI / 2;
      leftSide.position.x = -width / 2;
      this.card.add(leftSide);
      // 侧面（右）
      const rightSide = new THREE.Mesh(
        new THREE.PlaneGeometry(this.cardThickness, height),
        sideMaterial
      );
      rightSide.rotation.y = Math.PI / 2;
      rightSide.position.x = width / 2;
      this.card.add(rightSide);

      this.scene.add(this.card);

      // 5. 添加轨道控制器（用于鼠标交互）
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true; // 添加阻尼效果
      this.controls.dampingFactor = 0.05;
      this.controls.enableZoom = false; // 禁用缩放功能
      this.controls.enablePan = false; // 禁用平移功能（可选）

      // 6. 添加光源（可选）
      const ambientLight = new THREE.AmbientLight(0x404040);
      this.scene.add(ambientLight);

      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
      directionalLight.position.set(1, 1, 1);
      this.scene.add(directionalLight);

      // 7. 窗口大小调整处理
      window.addEventListener("resize", this.onWindowResize);
    },

    animate() {
      requestAnimationFrame(this.animate);

      // 如果用户没有在拖动，卡片自动旋转
      if (!this.isDragging) {
        this.card.rotation.x += this.rotationSpeed;
        this.card.rotation.y += this.rotationSpeed;
      }

      // 更新控制器
      if (this.controls) {
        this.controls.update();
      }

      // 渲染场景
      if (this.renderer && this.scene && this.camera) {
        this.renderer.render(this.scene, this.camera);
      }
    },

    setupEventListeners() {
      const renderer = this.renderer.domElement;

      // 鼠标按下事件
      renderer.addEventListener("mousedown", (event) => {
        this.isDragging = true;
        this.previousMousePosition = {
          x: event.clientX,
          y: event.clientY,
        };
      });

      // 鼠标移动事件
      renderer.addEventListener("mousemove", (event) => {
        if (this.isDragging) {
          const deltaMove = {
            x: event.clientX - this.previousMousePosition.x,
            y: event.clientY - this.previousMousePosition.y,
          };

          // 根据鼠标移动距离旋转卡片
          const deltaRotationQuaternion = new THREE.Quaternion().setFromEuler(
            new THREE.Euler(
              toRadians(deltaMove.y * 0.5),
              toRadians(deltaMove.x * 0.5),
              0,
              "XYZ"
            )
          );

          this.card.quaternion.multiplyQuaternions(
            deltaRotationQuaternion,
            this.card.quaternion
          );

          this.previousMousePosition = {
            x: event.clientX,
            y: event.clientY,
          };
        }
      });

      // 鼠标释放事件
      renderer.addEventListener("mouseup", () => {
        this.isDragging = false;
      });

      // 鼠标离开容器事件
      renderer.addEventListener("mouseleave", () => {
        this.isDragging = false;
      });

      // 触摸事件支持
      renderer.addEventListener(
        "touchstart",
        (event) => {
          this.isDragging = true;
          this.previousMousePosition = {
            x: event.touches[0].clientX,
            y: event.touches[0].clientY,
          };
          event.preventDefault();
        },
        { passive: false }
      );

      renderer.addEventListener(
        "touchmove",
        (event) => {
          if (this.isDragging) {
            const deltaMove = {
              x: event.touches[0].clientX - this.previousMousePosition.x,
              y: event.touches[0].clientY - this.previousMousePosition.y,
            };

            const deltaRotationQuaternion = new THREE.Quaternion().setFromEuler(
              new THREE.Euler(
                toRadians(deltaMove.y * 0.5),
                toRadians(deltaMove.x * 0.5),
                0,
                "XYZ"
              )
            );

            this.card.quaternion.multiplyQuaternions(
              deltaRotationQuaternion,
              this.card.quaternion
            );

            this.previousMousePosition = {
              x: event.touches[0].clientX,
              y: event.touches[0].clientY,
            };
          }
          event.preventDefault();
        },
        { passive: false }
      );

      renderer.addEventListener("touchend", () => {
        this.isDragging = false;
      });

      function toRadians(angle) {
        return angle * (Math.PI / 180);
      }
    },

    onWindowResize() {
      if (this.camera && this.renderer) {
        this.camera.aspect =
          this.$refs.imageContainer.clientWidth / this.$refs.imageContainer.clientHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(
          this.$refs.imageContainer.clientWidth,
          this.$refs.imageContainer.clientHeight
        );
      }
    },  
    cleanUp() {
    // 清理资源
    if (this.controls) {
      this.controls.dispose();
    }
    if (this.renderer) {
      this.renderer.dispose();
    }
   
    if (this.scene) {
      while (this.scene.children.length > 0) {
        this.scene.remove(this.scene.children[0]);
      }
      }
      const container = this.$refs.imageContainer;
      console.log("container01", container)
      container.remove()
      this.threeD_display02 = false
      this.threeD_display = true
 
    } ,
  },
  updated() {
    // updated需要重现渲染DOM  // 3D部分
    // ? 解决报错问题 * 航航:涉及到vue项目DOM渲染的底层问题
    if (this.threeD_display02) {
      this.initThree();
      this.animate();
      this.setupEventListeners();}
    },
    mounted() {
      this.queryCardTheme();
      this.getLayoutImageByBankCode();
      this.bankSerialNumber = localStorage.getItem("bankSerialNumber");
      this.process = this.$route.params.process;
      this.delImageUrl = this.$route.params.delImageUrl;
      this.taskId = this.$route.params.taskId;
      this.phone = localStorage.getItem('phone')
      this.prompt = this.$route.params.prompt;
      this.bankCode = config.config_demo.bankCode;
      console.log('bankSerialNumber:' + this.bankSerialNumber);
      console.log('bankCode:' + this.bankCode);
      var destImg = this.$route.params.targetImg;

   
      this.cardFace = destImg
      console.log('destImg:' + destImg)
     
      localStorage.setItem("cardFace", this.cardFace);
      console.log("cardFace--->",this.cardFace)
      var selectParam = this.$route.params.selectParam;
      console.log('selectParam:' + selectParam)
      if (selectParam !== undefined) {
        this.selectParam = JSON.parse(selectParam)
      }

      /* let themeParam = this.$route.params.cardTheme;
      console.log('themeParam:' + themeParam)
      if (themeParam !== undefined) {
        this.cardTheme = JSON.parse(themeParam)
        this.kadis = this.cardTheme.backgroudColorList;
        this.kgys = this.cardTheme.cardTechnologyList;
      } */

      this.cardOri = this.$route.params.cardOri;
      localStorage.setItem("cardOri", this.cardOri);
      console.log('cardOri:' + this.cardOri);
      if (this.cardOri == 0) {
        //横版
        this.isHorizontal = true;
        this.threeD_width = 4.6;//长
        this.threeD_height = 3 //宽
        this.backgroundImage = this.logUrlList.threeD_heng
      } else if (this.cardOri == 1) {
        //竖版
        this.isHorizontal = false;
        this.threeD_width = 3;//长
        this.threeD_height = 4.6 //宽
        this.backgroundImage = this.logUrlList.threeD_shu
      }

      if (1 == this.kgys.length) {
        this.kagongyi = this.kgys[0].id;
      }
      this.showCardFront = 0;
  },
  beforeDestroy() {
  //  this.cleanUp()
  },
};
</script>

<style scoped>
.threeDisplay01{
  width: 100%;
  height: 100%;
  /* background-color:#3861d5 */
}
.threeDisplay02{
  width: 100%;
  height: 100%;
  /* background-color:#3861d5 */
}
.threeD{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.card_arr_heng{
  padding: 10rem 0;
  margin: 0 auto;
  width: 14rem;
  height: 9rem;
  position: relative;
  transform-style: preserve-3d; /* 保持子元素3D空间 */
  transition: transform; /* 平滑过渡 */
  cursor: pointer;
  animation: rotate3d 8s infinite linear;
}
.card_arr_shu{
  padding: 10rem 0;
  margin: 0 auto;
  width: 9rem;
  height: 14rem;
  position: relative;
  transform-style: preserve-3d; /* 保持子元素3D空间 */
  transition: transform; /* 平滑过渡 */
  cursor: pointer;
  animation: rotate3d 5s infinite linear;
}
.card_front01{
 position: absolute;
 width: 14rem;
 height: 9rem;
 border-radius: 0.8rem;
 backface-visibility: hidden; /* 隐藏背面 */
 background: linear-gradient(45deg, #3861d5, #3861d5);
 transform: rotateY(180deg); /* 初始背面朝外 */
}
.card_front02{
 position: absolute;
 width: 9rem;
 height: 14rem;
 border-radius: 0.8rem;
 backface-visibility: hidden; /* 隐藏背面 */
 background: linear-gradient(45deg, #3861d5, #3861d5);
 transform: rotateY(180deg); /* 初始背面朝外 */
}
.card_back01{
 position: absolute;
 width: 14rem;
 height: 9rem;
 border-radius: 0.8rem;
 backface-visibility: hidden; /* 隐藏背面 */
 background: linear-gradient(45deg, #3861d5, #3861d5);
}
.card_back02{
 position: absolute;
 width: 9rem;
 height: 14rem;
 border-radius: 0.8rem;
 backface-visibility: hidden; /* 隐藏背面 */
 background: linear-gradient(45deg, #3861d5, #3861d5);
}

/* 旋转动画 */
@keyframes rotate3d {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}



.navigation {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(left, #3861d5, white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.three_arr{
  width: 30%;
  background-color: #3861d5;
  color: white;
  border-radius: 1rem ;
  font-size: 0.8rem;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
.subject {
  padding: 1.8rem 1.8rem 0;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
   background: linear-gradient(top, #3861d5, white);
}
/* .header {
  background-color: aqua;
  height: 3rem;
} */
/* .main {
  background-color: yellow;
  height: 3rem;
} */
 .BacktoHeadlines {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background-color: pink;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 30px;
}
.Previouspage {
  font-size: 16px;
  font-weight: 900;
}
.Maininterface {
  font-size: 16px;
  font-weight: 900;

}
  .lefttext {
    text-align: left;
    padding-left: 8px;
    padding-right: 8px;
  }

  .actionArea {
    margin-top: 32px;
    margin-bottom: 24px;
  }

  .cardFront {
    position: absolute;
    z-index: 25;
    left: 10px;
    top: 10px;
    width: 253px;
    height: 160px;
    border-radius: 4.5%;
  }

  .frontV {
    position: absolute;
    z-index: 25;
    width: 124px;
    height: 193px;
    left: 10px;
    top: 10px;
  }

  .cardFrontCover {
    position: absolute;
    z-index: 30;
    left: 10px;
    top: 10px;
    width: 253px;
    height: 160px;
    border-radius: 4.5%;
  }

  .frontCoverV {
    position: absolute;
    z-index: 30;
    width: 124px;
    height: 193px;
    left: 10px;
    top: 10px;
  }

  .cardBack {
    position: absolute;
    z-index: 15;
    left: 20px;
    top: 20px;
    width: 253px;
    height: 160px;
    border-radius: 4.5%;
  }

  .backV {
    position: absolute;
    z-index: 15;
    width: 124px;
    height: 193px;
    left: 20px;
    top: 20px;
  }

  .cardBackCover1 {
    position: absolute;
    z-index: 20;
    left: 20px;
    top: 20px;
    width: 253px;
    height: 160px;
    border-radius: 4.5%;
  }

  .backCoverV1 {
    position: absolute;
    z-index: 20;
    width: 124px;
    height: 193px;
    left: 20px;
    top: 20px;
  }

  .absoluteDiv {
    position: relative;
    width: 300px;
    height: 190px;
  }

  .vertical {
    position: relative;
    width: 140px;
    height: 220px;
  }

  .rootDiv {
    position: relative;
    background-color: #f1f2f3;
    margin-top: 8px;
    margin-bottom: 8px;
    padding-top: 16px;
    padding-bottom: 16px;
    width: 100%;
    border-radius:1rem ;
  }

  .cardFaceGroup {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    align-items: flex-end;
    height: 64px;
  }

  .cardFaceGroup input {
    display: none;
  }

  .cardFaceGroup label {
    color: gray;
    line-height: 28px;
    min-width: 20vw;
    min-height: 28px;
    text-align: center;
    border-radius: 4px;
    margin: 8px;
  }

  .cardFaceGroup input:checked+label {
    background-size: 21px 21px;
    font-weight: bold;
    color: black;
    margin: 8px;
  }

  .kadiItem {
    display: flex;
    width: 25%;
    height: 3rem;
  }

  .RadioStyle input {
    display: none
  }

  .RadioStyle label {
    border: 1px solid #00a4ff;
    color: #fff;
    line-height: 28px;
    min-width: 100%;
    min-height: 28px;
    text-align: center;
    float: left;
    font-size: 10px;
    border-radius: 4px;
  }

  .RadioStyle input:checked+label {
    border: 4px solid #00a4ff;
    background-size: 21px 21px;
    color: #fff;
  }

  .RadioStyle input:disabled+label {
    opacity: 0.7;
  }

  .parent {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 25%;
    height: 3rem;
    margin-left: 0.5rem;
    border-radius: 4px;
  }

  .imgDiv {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .chk_div input {
    display: none;
  }

  .chk_div label {
    background-size: 64px 48px;
    width: 64px;
    height: 40px;
    display: block;
    padding-left: 35px;
    padding-top: 5px;
    margin: 8px;
  }

  .chk_div input[type=radio]:checked+label {
    border: 4px solid #00a4ff;
    border-radius: 4px;
  }

  .rowItem {
    margin-top: 16px;
  }
/* 
  .rowItemNotice {
    margin-top: 16px;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: #f1f2f3;
  } */
.three_footer {
  /* background-color: blue; */
  padding: 12rem 3rem 0;
}
 .toPayButton{
  width: 100%;
  height: 2.8rem;
  background-color: #3861d5;
  color: white;
  border-radius: 1.4rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
 }
 .card_container {
  width: 100%;
  height: 24rem;
  background-color:white; /* 确保容器背景为白色 */
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/DIYApplyCardSurface/ApplicationCard/CustomLayout/UploadCardface_demo.vue